var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1111C0 4.97461 4.97461 0 11.1111 0H38.8889C45.0254 0 50 4.97461 50 11.1111V38.8889C50 45.0254 45.0254 50 38.8889 50H11.1111C4.97461 50 0 45.0254 0 38.8889V11.1111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.536 31.6148C11.2642 30.3431 11.2642 28.2812 12.536 27.0095L25.3194 14.2261C26.5911 12.9543 28.653 12.9543 29.9247 14.2261C31.1964 15.4978 31.1964 17.5597 29.9247 18.8314L17.1413 31.6148C15.8696 32.8865 13.8077 32.8865 12.536 31.6148Z",
    fill: "url(#paint0_linear_9304_7689)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0756 26.5489L24.859 13.7655C26.3851 12.2394 28.8593 12.2394 30.3854 13.7655C31.9115 15.2916 31.9115 17.7659 30.3854 19.2919L17.602 32.0753C16.0759 33.6014 13.6017 33.6014 12.0756 32.0753C10.5495 30.5493 10.5495 28.075 12.0756 26.5489ZM12.5361 27.0095C11.2644 28.2812 11.2644 30.3431 12.5361 31.6148C13.8079 32.8865 15.8697 32.8865 17.1415 31.6148L29.9249 18.8314C31.1966 17.5597 31.1966 15.4978 29.9249 14.2261C28.6532 12.9543 26.5913 12.9543 25.3195 14.2261L12.5361 27.0095Z",
    fill: "url(#paint1_linear_9304_7689)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5306 41.4504C23.8023 42.7221 25.8642 42.7221 27.1359 41.4504L43.5645 25.0218L41.0671 18.3085L22.5306 36.845C21.2588 38.1168 21.2588 40.1786 22.5306 41.4504Z",
    fill: "url(#paint2_linear_9304_7689)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3207 25.1865L41.3239 17.1305L22.07 36.3843C20.544 37.9104 20.544 40.3847 22.07 41.9107C23.5961 43.4368 26.0704 43.4368 27.5965 41.9107L44.3207 25.1865ZM22.5306 36.8448C21.2588 38.1166 21.2588 40.1785 22.5306 41.4502C23.8023 42.7219 25.8642 42.7219 27.1359 41.4502L43.5645 25.0217L41.0671 18.3083L22.5306 36.8448Z",
    fill: "url(#paint3_linear_9304_7689)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0596 41.5263C25.7879 42.798 23.726 42.798 22.4543 41.5263L6.02574 25.0978L8.52308 18.3844L27.0596 36.9209C28.3314 38.1927 28.3314 40.2546 27.0596 41.5263Z",
    fill: "url(#paint4_linear_9304_7689)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26952 25.2628L8.26633 17.2068L27.5202 36.4606C29.0463 37.9867 29.0463 40.4609 27.5202 41.987C25.9941 43.5131 23.5198 43.5131 21.9937 41.987L5.26952 25.2628ZM27.0596 36.9211C28.3314 38.1929 28.3314 40.2548 27.0596 41.5265C25.7879 42.7982 23.726 42.7982 22.4543 41.5265L6.02574 25.0979L8.52308 18.3846L27.0596 36.9211Z",
    fill: "url(#paint5_linear_9304_7689)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19589 21.9457C7.11419 24.0274 7.1388 25.7996 7.83224 26.9043L6.10523 25.1773C3.56177 22.6338 3.56139 18.5104 6.10486 15.9669L13.8108 8.26096C13.8108 8.26096 18.8174 12.3242 15.3093 15.8323L9.19589 21.9457Z",
    fill: "url(#paint6_linear_9304_7689)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7999 31.7866C38.0716 30.5148 38.0716 28.4529 36.7999 27.1812L18.0926 8.4739C16.8208 7.20216 14.7589 7.20216 13.4872 8.47389C12.2155 9.74563 12.2155 11.8075 13.4872 13.0792L32.1945 31.7866C33.4662 33.0583 35.5281 33.0583 36.7999 31.7866Z",
    fill: "url(#paint7_linear_9304_7689)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2601 26.7207L18.5528 8.01337C17.0267 6.48729 14.5525 6.48729 13.0264 8.01337C11.5003 9.53945 11.5003 12.0137 13.0264 13.5398L31.7337 32.2471C33.2598 33.7732 35.734 33.7732 37.2601 32.2471C38.7862 30.721 38.7862 28.2468 37.2601 26.7207ZM36.7996 27.1812C38.0713 28.4529 38.0713 30.5148 36.7996 31.7866C35.5278 33.0583 33.4659 33.0583 32.1942 31.7866L13.4869 13.0793C12.2152 11.8075 12.2152 9.74564 13.4869 8.4739C14.7586 7.20217 16.8205 7.20217 18.0923 8.47391L36.7996 27.1812Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8777 18.9421L25.2723 14.3368L31.6 8.00909C32.8718 6.73735 34.9337 6.73735 36.2054 8.00908C36.2382 8.04191 36.2702 8.07525 36.3013 8.1091C36.335 8.14001 36.3681 8.17177 36.4007 8.20439L43.8096 15.6133C46.3531 18.1568 46.3526 22.2801 43.8092 24.8236L42.0822 26.5506C42.7756 25.4459 42.8002 23.6737 40.7185 21.592L33.9732 14.8467L29.8777 18.9421Z",
    fill: "url(#paint8_linear_9304_7689)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 37.485H67.3502V28.2384L79.0165 28.2384V24.1709L67.3502 24.1709V18.1995C67.3502 17.7304 67.7304 17.3502 68.1995 17.3502L80.8668 17.3502V12.5H65.614C63.8942 12.5 62.5 13.8942 62.5 15.614V37.485Z",
    fill: "#0A2D53"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.057 12.5H102.256V37.5H107.057V12.5Z",
    fill: "#0A2D53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9441 29.7737H100.143L100.186 29.5417C100.291 28.9693 100.346 28.3794 100.346 27.777C100.346 22.4155 95.9995 18.0691 90.638 18.0691C85.2765 18.0691 80.9301 22.4155 80.9301 27.777C80.9301 27.825 80.9289 27.8823 80.9275 27.9436C80.9243 28.085 80.9207 28.2482 80.9312 28.3688L80.9334 28.3949C80.9654 28.7663 80.9872 29.0202 81.0652 29.4C81.0732 29.4474 81.0815 29.4946 81.0902 29.5418L81.1328 29.7737H81.1495C82.2364 34.2007 86.2313 37.485 90.9938 37.485C93.7944 37.485 96.3302 36.3488 98.1645 34.5129L98.3645 34.3127L95.3167 31.2649L95.119 31.5112C94.1497 32.7191 92.6621 33.4916 90.9938 33.4916C88.6206 33.4916 86.6122 31.9275 85.9441 29.7737ZM90.638 22.0625C92.9281 22.0625 94.8485 23.6475 95.3613 25.7803H85.9147C86.4275 23.6475 88.3479 22.0625 90.638 22.0625Z",
    fill: "#0A2D53"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.753 37.4849C124.114 37.4849 128.461 33.1385 128.461 27.777C128.461 22.4155 124.114 18.0691 118.753 18.0691C113.391 18.0691 109.045 22.4155 109.045 27.777C109.045 33.1385 113.391 37.4849 118.753 37.4849ZM123.611 27.777C123.611 30.9756 121.396 33.4915 118.753 33.4915C116.109 33.4915 113.895 30.9756 113.895 27.777C113.895 24.5785 116.109 22.0625 118.753 22.0625C121.396 22.0625 123.611 24.5785 123.611 27.777Z",
    fill: "#0A2D53"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9304_7689",
    x1: 14.7103,
    y1: 27.2299,
    x2: 27.0627,
    y2: 14.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9304_7689",
    x1: 18.775,
    y1: 30.9319,
    x2: 31.8075,
    y2: 16.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9304_7689",
    x1: 27.5663,
    y1: 38.6252,
    x2: 43.3961,
    y2: 23.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9304_7689",
    x1: 24.0075,
    y1: 34.4174,
    x2: 41.5223,
    y2: 18.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9304_7689",
    x1: 22.0239,
    y1: 38.7012,
    x2: 6.19408,
    y2: 23.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9304_7689",
    x1: 25.5827,
    y1: 34.4937,
    x2: 8.06795,
    y2: 19.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.608525,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9304_7689",
    x1: 5.47221,
    y1: 19.8924,
    x2: 14.3733,
    y2: 10.7042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9304_7689",
    x1: 33.5082,
    y1: 26.2843,
    x2: 17.1391,
    y2: 8.50697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9304_7689",
    x1: 42.3796,
    y1: 24.8617,
    x2: 23.4878,
    y2: 13.1992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182306,
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907412,
    stopColor: "#273DFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6dad5b58da2dab958b9627bc4ff9b264.svg";
export { ForwardRef as ReactComponent };